import { useEffect } from 'react';
import { useTheme } from 'next-themes';

type NativeBridge = { postMessage: (message: string) => void };

/**
 * Tells the mobile app shell (React Native WebView) the theme the page uses, so the native status bar and the
 * top / bottom safe-area margins follow it. Sends the resolved theme (light / dark, also for "system") and the
 * page background colour. Renders nothing; outside the mobile app it does nothing.
 */
export function NativeThemeSync() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const bridge = (window as unknown as { ReactNativeWebView?: NativeBridge }).ReactNativeWebView;
    if (!bridge || !resolvedTheme) return;

    // ThemeProvider (a parent) sets the class in its own effect, which runs after this one: read the colour next
    const timer = setTimeout(() => {
      try {
        bridge.postMessage(JSON.stringify({
          type: 'SET_THEME',
          theme: resolvedTheme === 'dark' ? 'dark' : 'light',
          backgroundColor: getComputedStyle(document.body).backgroundColor,
        }));
      } catch {
        // The shell may not handle this message yet (older app version)
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [resolvedTheme]);

  return null;
}
